import api from './api'

export const performanceService = {
  // Get all performances
  async getPerformances() {
    const response = await api.get('/performances/')
    return response.data
  },

  // Get upcoming performances
  async getUpcomingPerformances() {
    const response = await api.get('/performances/upcoming')
    return response.data
  },

  // Get a specific performance
  async getPerformance(id) {
    const response = await api.get(`/performances/${id}`)
    return response.data
  },

  // Create a new performance (admin)
  async createPerformance(data) {
    const response = await api.post('/performances/', data)
    return response.data
  },

  // Update a performance (admin)
  async updatePerformance(id, data) {
    const response = await api.put(`/performances/${id}`, data)
    return response.data
  },

  // Delete a performance (admin)
  async deletePerformance(id) {
    const response = await api.delete(`/performances/${id}`)
    return response.data
  }
}
